import {
  FETCH_PRICEBANNER_PARAMS_SUCCESS,
  FETCH_PRICEBANNER_PARAMS_ERROR,
  SAVE_PRICEBANNER_PARAMS_SUCCESS,
  SAVE_PRICEBANNER_PARAMS_ERROR,
  DELETE_PRICEBANNER_PARAMS_ERROR,
  UPDATE_PRICEBANNER_PARAMS_SUCCESS,
  UPDATE_PRICEBANNER_PARAMS_ERROR,
  DELETE_PRICEBANNER_PARAMS_SUCCESS

} from 'constants/actionTypes'

const DEFAULT_STATE = {
  error: null,
  errorSave: null,
  dataSave: null,
  list: [],
  metadata: {}, // pagination
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRICEBANNER_PARAMS_SUCCESS:
      return {
        ...state,
        error: null,
        list: action.payload?.data ?? [], 
        metadata: action.payload?.metadata ?? {},
      }

    case SAVE_PRICEBANNER_PARAMS_SUCCESS:
      return {
        ...state,
        dataSave: action.payload,
        errorSave: null,
      }

    case SAVE_PRICEBANNER_PARAMS_ERROR:
      return {
        ...state,
        dataSave: null,
        errorSave: action.payload,
      }
      
    case FETCH_PRICEBANNER_PARAMS_ERROR:
    case DELETE_PRICEBANNER_PARAMS_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_PRICEBANNER_PARAMS_SUCCESS:
    return {
      ...state,
      dataSave: action.payload,
      errorSave: null,
    };

    case UPDATE_PRICEBANNER_PARAMS_ERROR:
    return {
      ...state,
      dataSave: null,
      errorSave: action.payload,
    };

    case DELETE_PRICEBANNER_PARAMS_SUCCESS:
    return {
      ...state,
      error: null,
    }  

    default:
      return state
  }
}
